import React from 'react'
import SettlementsListTab from './SettlementsListTab'
import SettlementsPageLayout from './SettlementsPageLayout'
import { SETTLEMENT_INDEX_TAB } from './constants/constants'

export default function SettlementsIndex() {
  return (
    <SettlementsPageLayout activeTab={SETTLEMENT_INDEX_TAB.SETTLEMENTS}>
      <SettlementsListTab />
    </SettlementsPageLayout>
  )
}
